module.exports = __webpack_public_path__ + "static/media/smelter1.eaa7ad1e.jpg";